import { scribeHttpV2 } from '@/utils/scribeHTTP';
import type { ClientCapabilities } from '@heidi/agents/contracts';

export interface DesktopTarget {
  target_id: string;
  instance_id: string;
  display_name: string;
  app_version: string;
  capabilities: ClientCapabilities;
  last_seen_at: string;
  is_available: boolean;
  /** Run currently holding this target's single assignment slot. A busy
   *  target is still selectable — new runs queue at the resource gate and
   *  start automatically when the holder finishes. */
  busy_agent_run_id?: string | null;
  /** Cloud targets only: the bundled in-VM heidi-rpa-agent has a live
   *  heartbeat, so tools run through the native dispatch path (full
   *  accessibility + file tools) instead of the Daytona executor. */
  native_agent_connected?: boolean;
  /** True for cloud Resident VMs, false/absent for native desktops. Gates
   *  cloud-only UI such as the inline live view. */
  is_cloud?: boolean;
}

export interface DesktopTargetListResponse {
  targets: DesktopTarget[];
}

// UNCARVED DOMAIN KEY (rpa, CUA-44): rpa has no workspace package
export const DESKTOP_TARGETS_QUERY_KEY = ['rpa', 'desktop-targets'] as const;

export const desktopTargetsClient = {
  // Explicit timeout: the roster fetch is awaited before turn submission in
  // request-serving paths, and the shared axios instances have no default
  // timeout — a stalled fetch must not hang a turn indefinitely.
  list: () =>
    scribeHttpV2.get<DesktopTargetListResponse>('/rpa/desktop-targets', {
      timeout: 10_000,
    }),
};
